export default __webpack_public_path__ + "static/media/Deathgird.5137c9af.jpg";